<template>
    <div class="sidebar__section sidebar__section--vertical-padding ui-overflow-hidden" v-if="poi.videoPicture">
        <div class="poi-video-picture" @click="trackingEvent">
            <div class="poi-video-picture__inner">
                <a class="poi-video-picture__link" :href="poi.videoPicture.url" target="_blank"></a>
                <img v-if="poi.videoPicture.type && poi.videoPicture.type === 'image'" class="poi-video-picture__image" :src="poi.videoPicture.url" :alt="poi.videoPicture.alt">
                <iframe v-else class="poi-video-picture__iframe" scrolling="no" :src="poi.videoPicture.url" :alt="poi.videoPicture.alt"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
import { trackEvent, trackGa4Event } from '@/utils/tracking'
export default {
    props: {
        poi: {
            type: Object,
            default: () => {}
        },
    },

    methods: {
        trackingEvent() {
            trackEvent({ category: 'Traffic', action: 'Current Traffic', label: 'Live Camera' });
            trackGa4Event({ga4Parameter1Name: 'current_traffic', ga4Parameter1Value: 'live_cam', ga4Event: 'traffic'})
        }
    },
}
</script>

<style lang="scss">
.poi-video-picture {
    &__inner {
        position: relative;
        border-radius: $standard-border-radius;
        overflow: hidden;

        &:after {
            content: '';
            display: block;
            padding-bottom: (261 * 100% / 318);
        }
    }
    &__link {
        @include fillout;
        z-index: 2;
    }
    &__iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        overflow: hidden;
    }

    &__image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
</style>